var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "password-wrap", staticStyle: { position: "relative" } },
    [
      _vm.type == "el-input"
        ? _c("el-input", {
            ref: "passwordInput",
            attrs: {
              placeholder: _vm.placeholder,
              type: "password",
              width: _vm.width,
              "show-password": "",
              disabled: _vm.disabled,
            },
            on: { input: _vm.handleFocus, blur: _vm.handleBlur },
            model: {
              value: _vm.password,
              callback: function ($$v) {
                _vm.password = $$v
              },
              expression: "password",
            },
          })
        : _c("input-item", {
            ref: "passwordInput",
            attrs: {
              placeholder: _vm.placeholder,
              type: "password",
              width: _vm.width,
              "show-password": "",
              disabled: _vm.disabled,
            },
            on: { input: _vm.handleFocus, blur: _vm.handleBlur },
            model: {
              value: _vm.password,
              callback: function ($$v) {
                _vm.password = $$v
              },
              expression: "password",
            },
          }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showRules,
              expression: "showRules",
            },
          ],
          staticClass: "password-rules",
          style: _vm.type === "el-input" ? "top: 88px;" : "top: 48px;",
        },
        [
          _c("p", { staticClass: "rules-title" }, [
            _vm._v(_vm._s(_vm.$t("login.passwordValidator.title"))),
          ]),
          _vm._l(_vm.rules, function (rule) {
            return _c("div", { key: rule.ruleId, staticClass: "rule-item" }, [
              _c("i", { class: _vm.getRuleIconClass(rule.ruleId) }),
              _c("span", [_vm._v(_vm._s(rule.checkMessage))]),
            ])
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }